import {MutationTree} from 'vuex';
import {PlantaModel, PlantaState} from './types'

type PlantaMutationTree = MutationTree<PlantaState>;

export const mutations : PlantaMutationTree={
    setPlantas(state: PlantaState, payload: PlantaModel[]){
        state.plantas=payload;
    }
}